// @module Ames.RotateImages.RotateImages
define("Ames.RotateImages.RotateImages.View", [
  "ames_rotateimages_rotateimages.tpl",

  "Ames.RotateImages.RotateImages.SS2Model",

  "Backbone",

  "ProductDetails.ImageGallery.View"
], function (
  ames_rotateimages_rotateimages_tpl,

  RotateImagesSS2Model,

  Backbone,
) {
  "use strict";

  // @class Ames.RotateImages.RotateImages.View @extends Backbone.View
  return Backbone.View.extend({
    template: ames_rotateimages_rotateimages_tpl,

    initialize: function (options) {
      var container = options.container;
      var layout = container.getComponent("Layout");

      this.showrotator = true;
      var self = this;

      layout.on("afterShowContent", function () {
        if (self.showrotator) {
          $(".product-details-image-gallery-detailed-image").hide();
          window.CI360.init();
        }
      });
    },

    events: {},

    bindings: {},

    childViews: {},

    //@method getContext @return Ames.RotateImages.RotateImages.View.Context
    getContext: function getContext() {
      //@class Ames.RotateImages.RotateImages.View.Context
      this.message = this.message || "Hello World!!";
      return {
        message: this.message,
      };
    },
  });
});
